//
import React, { Component } from 'react';
import { Modal, Row, Col, DatePicker, Select, Input } from 'antd';
import moment from 'moment';
import { getCookie } from './../../../hook';

import currency from './../../../currency';

const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';
const Option = Select.Option;

export default class NewExpense extends Component {

    constructor( props ){

        super( props ); 

        this.state = {
            visible: false,
            userType: '',
            user: '',
            date: '',
            description: '',
            amount: 0,
            currency: 'AED',
            currency_rate: 1,   
            users_list: [],
        }

        this.handleCancel = this.handleCancel.bind( this );
        this.handleOk = this.handleOk.bind( this );

    }

    componentWillMount(){

        const user = getCookie('dv_hrms_user').split(',');
        const todayDate = moment().format( dateFormat );

        this.setState({ 
            userType: user[3],
            user: user[1],
            date: '',
            description: '',
            amount: 0,
            currency: 'AED',
            currency_rate: 1,
            date: todayDate 
        });
    }

    componentWillReceiveProps( nextProps ){

        const todayDate = moment().format( dateFormat );
        const user = getCookie('dv_hrms_user').split(',');

        this.setState({
            userType: user[3],
            visible: nextProps.onVisible,
            user: user[1],
            date: '',
            description: '',
            amount: 0,
            currency: 'AED',
            currency_rate: 1,
            date: todayDate,
            users_list: nextProps.users
        });
    
    }

    handleCancel(){
        this.props.onCancel();
    }

    handleOk(){

        let tempData = {
            user: this.state.user,
            date: this.state.date,
            description: this.state.description,
            amount: this.state.amount,
            currency: this.state.currency,
            currency_rate: this.state.currency_rate 
        }

        this.props.onSubmit( tempData );

    }

    render() {

        const currency_list = currency.map( (item, k ) => <Option value={ item }>{ item }</Option> );
        const users_list = this.state.users_list.map( ( item, k) => <Option value={ item.user_id }>{ item.full_name }</Option> )

        return (
            <Modal
                title="New Expense"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className="expense_label">Employee</label>
                        <Select
                            showSearch
                            disabled={ ( this.state.userType !== 'admin' ) ? true: false }
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={ (value) => this.setState({ user: value }) }
                            style={{ width: '100%' }}
                            defaultValue={ this.state.user }>
                            { users_list }
                        </Select>
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className="expense_label">Date</label>
                        <DatePicker 
                            style={{width: '100%'}}
                            defaultValue={moment( this.state.date, dateFormat)}
                            onChange={ ( date, dateString ) => this.setState({ date: dateString }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={24}>
                        <label className="expense_label">Description</label>
                        <TextArea 
                            value={ this.state.description }
                            onChange={ (e) => this.setState({ description: e.target.value }) }
                            style={{width: '100%'}}
                            rows={2} />
                    </Col>
                </Row>

                <Row className="mrg_b_10" gutter={16}>
                    <Col span={8}>
                        <label className="expense_label">Amount</label>
                        <Input 
                            style={{ width: '100%' }}
                            value={ this.state.amount }
                            onChange={ (e) => this.setState({ amount: e.target.value }) } />
                    </Col>
                    <Col span={8}>
                        <label className="expense_label">Currency</label>
                        <Select
                            showSearch
                            onChange={ ( value ) => this.setState({ currency: value }) } 
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            defaultValue={ this.state.currency }  
                            style={{ width: '100%' }}>
                            { currency_list }
                            <Option value="Other">Other</Option>
                        </Select>
                    </Col>
                    <Col span={8}>
                        <label className="expense_label">Currency Rate</label>
                        <Input 
                            style={{ width: '100%' }}
                            value={ this.state.currency_rate }
                            onChange={ (e) => this.setState({ currency_rate: e.target.value }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label className="expense_label">Amount AED</label>
                        <h2>{ this.state.amount*this.state.currency_rate } - / AED</h2>
                    </Col>
                </Row>

            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/expense/childs/new.expense.js